// components/Header.tsx
'use client';

import { Search, Bell, HelpCircle, Settings, Menu, LogOut } from 'lucide-react';
import { thememain } from '@/theme/colors';
import { useTheme } from '@/theme/ThemeContext';
import { useRouter } from 'next/navigation';
import ButtonTheme from './btntheme';

export default function Header() {
  const { theme, toggleTheme } = useTheme();
  const router = useRouter();

  async function handleLogout() {
    await fetch('/api/auth/logout', { method: 'POST' });
    router.push('/login');
    router.refresh();
  }
 
  return (
<header 
  className={`h-20 backdrop-blur-md px-6 flex items-center justify-between sticky top-0 z-30 border-b transition-colors duration-200 ${
    theme === 'light'
      ? 'bg-slate-50/80 border-slate-200/60'
      : 'bg-slate-100/90 border-slate-300/80'
  }`}
>
      {/* Barra de Búsqueda Estilo Drive */}
      <div className="flex-1 max-w-xl ml-12 md:ml-0">
        <span className={`relative flex items-center text-2xl font-bold tracking-wide ${thememain.colors.bluemain}`}>ASCI DC3</span>
        {/* <div className="relative flex items-center">
          <Search className="absolute left-4 text-slate-400" size={20} />
          <input
            type="text"
            placeholder="Buscar en el sistema..."
            className="w-full bg-slate-200/60 hover:bg-slate-200 focus:bg-white focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500 text-slate-800 placeholder-slate-500 pl-12 pr-4 py-3 rounded-full outline-none transition-all text-sm shadow-inner"
          />
        </div> */}
      </div>

      {/* Iconos de Utilidades y Perfil de Usuario */}
      <div className="flex items-center gap-3 ml-4">


        {/* <button onClick={toggleTheme} className={`px-4 py-2 rounded-xl font-medium transition-colors shadow-sm ${theme === 'dark'
            ? 'bg-slate-800 text-white hover:bg-slate-700'
            : 'bg-blue-600 text-white hover:bg-blue-700'
          }`}>
          Cambiar a modo {theme === 'light' ? 'oscuro' : 'claro'}
        </button> */}
        <ButtonTheme />

        <div className="h-6 w-[1px] bg-slate-300 mx-1" />

        {/* Avatar de Usuario */}
        <div className="flex items-center gap-3 pl-1">
          <div className="w-10 h-10 rounded-full bg-blue-600 text-white font-bold flex items-center justify-center shadow-md cursor-pointer hover:opacity-90 transition">
            MA
          </div>
        </div>

        {/* Cerrar sesión */}
        <button
          onClick={handleLogout}
          title="Cerrar sesión"
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium text-slate-500 hover:text-red-600 hover:bg-red-50 transition"
        >
          <LogOut size={16} />
          <span className="hidden sm:inline">Salir</span>
        </button>
      </div>

    </header>
  );
}